<div novalidate autocomplete="off">
	<div class="apply-all-card-group">
		<div class="inner-group">
			<div class="element-group">
				<mat-checkbox [(ngModel)]="isTransportModeChecked"></mat-checkbox>
				<mat-form-field subscriptSizing="dynamic" class="copo-content-product card-header-double-span copo-form-field"
					(click)="$event.stopPropagation()" floatLabel="always">
					<mat-label translate>transport.mode</mat-label>
					<mat-select [(ngModel)]="transportModeSelected" class="copo-content-field">
						<mat-option *ngFor="let tmode of tmodeList" [value]="tmode.code" [matTooltip]="tmode.description">
							<span>{{tmode.description}}</span></mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="element-group" *ngIf="displayShipTo && shipToList.length > 0">
				<mat-checkbox [(ngModel)]="isShipToPartyChecked"></mat-checkbox>
				<mat-form-field subscriptSizing="dynamic"
					class="copo-content-product card-header-double-span copo-form-field" floatLabel="always">
					<mat-label
							translate>eorder.wizard.order.shipto.name</mat-label>
					<mat-select #shipToField class="copo-content-field" [(ngModel)]="shipToSelected">
						<mat-option *ngFor="let shipTo of getShipToList()| copoSortOptions:false: configForBoc" [value]="shipTo.businessId">
							<div class="copo-ship-to-name" [matTooltip]="shipTo.name +' / '+ shipTo.city">{{shipTo.name}}&nbsp;/&nbsp;{{shipTo.city}}</div>
							<div class="copo-ship-to-address" *ngIf="shipToField.panelOpen"
								[matTooltip]="shipTo.address +' '+ (shipTo.postalCode ? shipTo.postalCode : '') + ' ' + shipTo.city + ' (' + shipTo.country + ')'">
								{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
							</div>
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="element-group rdd-group">
				<mat-checkbox [(ngModel)]="isRDDChecked"></mat-checkbox>
				<div class="rdd-inner-group">
					<mat-form-field subscriptSizing="dynamic" [hideRequiredMarker]="true" class="copo-content-product card-header-double-span copo-form-field small"
						floatLabel="always">
						<mat-label translate>eorder.wizard.product.rdd.type</mat-label>
						<mat-select [(ngModel)]="rddTypeSelected" class="copo-content-field" [compareWith]="compareWithFn">
							<mat-option *ngFor="let rddType of rddTypes" [value]="rddType.code">
								<span>{{ rddType.value }}</span>
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field subscriptSizing="dynamic" [hideRequiredMarker]="true" class="opo-content-product card-header-double-span copo-form-field medium"
						floatLabel="always">
						<mat-label translate>eorder.wizard.product.rdd</mat-label>
						<input matInput spellcheck="false" [(ngModel)]="rddDateSelected" autocomplete="off" readonly
							[copoDatepicker]="startDatepicker" [copoFormat]="getDateFormat()" (click)="startDatepicker.open()"
							#startDateInput (focus)="startDateInput.blur()" [min]="calStartDate"
							[max]="calEndDate">
						<mat-datepicker-toggle matSuffix class="filter-icon multiple-sufix cal-icon-color apply-datepicker-toggle"
							[for]="startDatepicker"></mat-datepicker-toggle>
						<mat-datepicker #startDatepicker class="copo-applyall"></mat-datepicker>
					</mat-form-field>
				</div>
			</div>
			<div class="element-group" *ngIf="serviceLevelList && serviceLevelList.length > 0">
				<mat-checkbox [(ngModel)]="isServiceLevelChecked"></mat-checkbox>
				<mat-form-field subscriptSizing="dynamic"
					class="copo-content-product card-header-double-span copo-form-field"
					(click)="$event.stopPropagation()" floatLabel="always">
					<mat-label
							translate>global.servicelevel</mat-label>
					<mat-select [(ngModel)]="serviceLevelSelected" [compareWith]="compareWithFn" class="copo-content-field">
						<mat-option *ngFor="let serviceLevel of serviceLevelList" [value]="serviceLevel.code"
							[matTooltip]="serviceLevel.description">
							<span>{{serviceLevel.description}}</span></mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="element-group" *ngIf="xcarbParamList && xcarbParamList.length > 0">
				<mat-checkbox [(ngModel)]="isXCarbChecked"></mat-checkbox>
				<mat-form-field subscriptSizing="dynamic"
					class="copo-content-product card-header-double-span copo-form-field"
					(click)="$event.stopPropagation()" floatLabel="always">
					<mat-label class="xcarb-label" translate>xcarb.label</mat-label>
					<mat-select [(ngModel)]="xcarbSelected" [compareWith]="compareWithFn" class="copo-content-field">
						<mat-option *ngFor="let xcarb of xcarbParamList" [value]="xcarb.code"
							[matTooltip]="xcarb.description">
							<span>{{xcarb.description}}</span></mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="element-group" *ngIf="businessTypes && businessTypes.length > 0">
				<mat-checkbox [(ngModel)]="isBusinessTypeChecked"></mat-checkbox>
				<mat-form-field subscriptSizing="dynamic"
					class="copo-content-product card-header-double-span copo-form-field"
					(click)="$event.stopPropagation()" floatLabel="always">
					<mat-label
							translate>global.business-type</mat-label>
					<mat-select [(ngModel)]="businessTypeSelected" [compareWith]="compareWithFn" class="copo-content-field">
						<mat-option *ngFor="let  businessType of businessTypes" [value]=" businessType.businessCode"
							[matTooltip]=" businessType.businessDescription">
							<span>{{ businessType.businessDescription}}</span></mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
		<div class="apply-all-block">
			<a class="copo-applyall" (click)="$event.preventDefault();onApplyAll()" href="#">
				<u>Apply for All</u>
			</a>
		</div>
	</div>
</div>